
import { Component, Vue } from "vue-property-decorator";
import apiService from "@/services/apiService/apiService";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { SettingsMutations } from "@/components/settings/types";
import { Action, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { UserInfo, UserLanguage } from "@/services/apiService/api.types";
import CheckIcon from "@/assets/svg/svg-settings/CheckIcon.vue";
import { defaultUserInfo } from "@/helpers/constants";
import apiStorageInterface from "@/services/apiStorageInterface";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";

@Component({
  components: { CheckIcon }
})
export default class LanguageSelect extends Vue {
  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  alertReset!: (alertData: AlertState) => void;

  @Mutation(SettingsMutations.setOpenRightSideMenu, {
    namespace: Namespace.Settings
  })
  setOpenRightSideMenu!: (overlayStatus: boolean) => void;

  languageList: UserLanguage[] = [];

  formPos = 0;

  userInfo: UserInfo = defaultUserInfo;

  async mounted(): Promise<void> {
    const { items } = await apiService.getLanguages();
    this.languageList = items;

    this.userInfo = await apiStorageInterface.fetchUserInfo();
  }

  closeMenu(): void {
    this.setOpenRightSideMenu(false);
    SpatialNavigation.resume();
  }

  async handleFormActions(event: KeyboardEvent): Promise<void> {
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_DOWN:
        if (this.formPos < this.languageList.length - 1) {
          this.formPos++;
          SpatialNavigation.focus("#" + this.languageList[this.formPos].code);
        }
        break;
      case KeySet.KEY_UP:
        if (this.formPos > 0) {
          this.formPos--;
          SpatialNavigation.focus("#" + this.languageList[this.formPos].code);
        }
        break;
      case KeySet.KEY_BACK:
        this.closeMenu();
        break;
      case KeySet.KEY_ENTER:
        try {
          await apiService.changeUserLanguage(
            this.languageList[this.formPos].id
          );
          this.alertReset({
            show: true,
            message: "Please restart the application to apply changes",
            alertType: AlertType.Success
          });
        } catch (e) {
          console.log(e);
        }
        break;
    }
  }
}
